import React, { useState } from 'react';
import arrow from '../Icons/arrow.svg';
import Sidebar from '../Components/Siderbar';
import Footer from '../Components/Footer';
import Select from 'react-select';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';


const AddPriceHeads = () => {
  const epicxTenantId = localStorage.getItem('epicxTenantId');
  console.log('Tenant ID:', epicxTenantId);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const AuthorizationToken = localStorage.getItem('token');
  const [isActivePriceHeads, setIsActivePriceHeads] = useState(false);
  const [selectedPriceCategories, setSelectedPriceCategories] = useState([]);
  const [priceHeadsName, setPriceHeadsName] = useState('');
  const [priceHeadsType, setPriceHeadsType] = useState('');
  const [priceHeadsValue, setPriceHeadsValue] = useState('');
  const [priority, setPriority] = useState('');
  const [effectiveDate, setEffectiveDate] = useState('');
  const [expirationDate, setExpirationDate] = useState('');
  const [priceHeadsDescription, setPriceHeadsDescription] = useState('');

  const resetForm = () => {
    setPriceHeadsName('');
    setPriceHeadsType('');
    setPriceHeadsValue('');
    setPriority('');
    setSelectedPriceCategories([]);
    setEffectiveDate('');
    setExpirationDate('');
    setIsActivePriceHeads(null);
    setPriceHeadsDescription('');
  };

  const validateForm = () => {
    if (!priceHeadsName) {
      toast.error('Price Heads Name is required');
      return false;
    }
  
    if (!priceHeadsType) {
      toast.error('Price Heads Type is required');
      return false;
    }
  
    if (!priceHeadsValue || isNaN(priceHeadsValue)) {
      toast.error('Price Heads Value must be a valid number');
      return false;
    }
  
    // if (!priority || isNaN(priority)) {
    //   toast.error('Priority must be a valid number');
    //   return false;
    // }
  
    if (!selectedPriceCategories.length) {
      toast.error('Please select at least one applicable category');
      return false;
    }
  
    if (!effectiveDate) {
      toast.error('Effective Date is required');
      return false;
    }
  
    if (!expirationDate) {
      toast.error('Expiration Date is required');
      return false;
    }
  
    if (new Date(effectiveDate) >= new Date(expirationDate)) {
      toast.error('Effective Date must be earlier than Expiration Date');
      return false;
    }
  
    if (!priceHeadsDescription) {
      toast.error('Price Heads Description is required');
      return false;
    }
  
    return true; 
  };
  
  const handleSubmit = async (event) => {
    if (!validateForm()) {
        return; 
      }

    event.preventDefault();

    const data = {
      priceHeadsName,
      priceHeadsType,
      priceHeadsValue,
      priority,
      applicableCategories: selectedPriceCategories.map(option => option.value),
      effectiveDate,
      expirationDate,
      ActiveorDeactivatePriceHeads: isActivePriceHeads,
      priceHeadDescription: priceHeadsDescription
    };

    const epicxTenantId = localStorage.getItem('epicxTenantId');
    if (!epicxTenantId) {
      console.error('Tenant ID is not provided');
      return;
    }

    try {
      const response = await axios.post(`${BASE_URL}/promoCode/api/priceHeads/${epicxTenantId}`, data, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${AuthorizationToken}`,
        }
      });
      toast.success('Price heads added successfully');
      console.log('Price heads added successfully:', response.data);
      resetForm();
    } catch (error) {
      toast.error('Error adding Price heads. Please try again');
      console.error('Error adding Price heads:', error);
    }
  };

  const handleTogglePriceHeads = () => {
    setIsActivePriceHeads(!isActivePriceHeads);
  };
    const categoriesOptions =[
      { value: 'category1', label: 'Category 1' },
      { value: 'category2', label: 'Category 2' },
      { value: 'category3', label: 'Category 3' },
    ]

  // Custom styles for react-select
  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: '#f8f9fa', 
      borderColor: '#ced4da',
      boxShadow: 'none',
      '&:hover': {
        borderColor: '#80bdff',
      },
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999, 
    }),
  };

  return (
    <>
    <Sidebar/>
    <div style={{height:'92vh',overflowY:'auto',width:'100%'}}>
        <div className="container">
            <div>
            <h5 style={{padding:'20px'}}>Price Heads</h5>
            </div>
            <div style={{display:'flex',flexDirection:'column',gap:'20px',paddingBottom:'20px'}}>
                <div className="card">
                    <div className="card-header bg-light d-flex justify-content-between align-items-center">
                        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="10" fill="green" stroke="white" strokeWidth="2" />
                            <path d="M8 12h8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <h5>Price Heads Information</h5>
                        <div style={{display:'flex',justifyContent:'flex-end',width:'100%'}}>
                        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                            <circle cx="12" cy="12" r="10" fill="green" stroke="white" strokeWidth="2" />
                            <path d="M8 12l2 2 4-4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="2" fill="red" />
                        <path d="M8 8l8 8M16 8l-8 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        </div>
                    </div>
                    <div className="card-body" style={{display:'flex',flexDirection:'column',gap:'10px'}}>
                    <div className="row">
                      <div className="col">
                        <label htmlFor="priceHeadsName">Price Heads Name</label>
                        <span style={{ color: 'red' }}>*</span>
                        <input type="text" className="form-control bg-light" id="priceHeadsName" 
                        value={priceHeadsName} onChange={(e) => setPriceHeadsName(e.target.value)}/>
                      </div>
                      <div className="col">
                        <label htmlFor="priceHeadsType">Price Heads Type</label>
                        <span style={{ color: 'red' }}>*</span>
                        <select className="form-control bg-light" id="priceHeadsType" style={{
                                            backgroundImage: `url(${arrow})`,
                                            backgroundPosition: 'right 10px center',
                                            backgroundRepeat: 'no-repeat',
                                            backgroundSize: '16px 16px', 
                                            paddingRight: '30px',
                                            color:'gray'
                                        }}value={priceHeadsType} onChange={(e) => setPriceHeadsType(e.target.value)}>
                          <option value="">Select Type</option>
                          <option value="type1">Type 1</option>
                          <option value="type2">Type 2</option>
                          <option value="type3">Type 3</option>
                        </select>
                      </div>
                      <div className="col">
                        <label htmlFor="priceHeadsValue">Price Heads Value</label>
                        <span style={{ color: 'red' }}>*</span>
                        <input type="text" className="form-control bg-light" id="priceHeadsValue" 
                       value={priceHeadsValue} onChange={(e) => { const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                          setPriceHeadsValue(value);
                        } else {
                          toast.error('Only numeric values are allowed');
                        }
                      }}/>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                    <label htmlFor="applicableCategories">Applicable Categories</label>
                    <span style={{ color: 'red' }}>*</span>
                    <Select
                      id="applicableCategories"
                      options={categoriesOptions}
                      isMulti
                      value={selectedPriceCategories}
                      onChange={setSelectedPriceCategories}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      styles={customStyles}
                    />
                  </div>
                      <div className="col">
                        <label htmlFor="effectiveDate">Effective Date</label>
                        <span style={{ color: 'red' }}>*</span>
                        <input type="date" className="form-control bg-light" id="effectiveDate" 
                        value={effectiveDate} onChange={(e) => setEffectiveDate(e.target.value)}/>
                      </div>
                      <div className="col-md-4">
                        <label htmlFor="expirationDate">Expiration Date</label>
                        <span style={{ color: 'red' }}>*</span>
                        <input type="date" className="form-control bg-light" id="expirationDate"
                        value={expirationDate} onChange={(e) => setExpirationDate(e.target.value)} />
                      </div>
                    </div>
                    <div className="row">
                      
                      <div className="col-md-4">
                        <label>Active or Deactivate Price Heads</label>
                        {/* <span style={{ color: 'red' }}>*</span> */}
                        <div className="form-check form-switch" style={{marginLeft:'25px'}}>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="priceHeadsToggle"
                            checked={isActivePriceHeads}
                            onChange={handleTogglePriceHeads}
                            style={{ backgroundColor: isActivePriceHeads ? '#1ea072' : '' ,fontSize:'25px',  border: isActivePriceHeads ? 'none' : '', 
                              outline: isActivePriceHeads ? 'none' : '',}}
                          />
                          <label className="form-check-label" htmlFor="priceHeadsToggle">
                            {isActivePriceHeads ? 'Active' : 'Deactivate'}
                          </label>
                        </div>
                      </div>
                      <div className="col">
                            <label htmlFor="priceHeadsDescription">Description</label>
                            <span style={{ color: 'red' }}>*</span>
                            <textarea
                              className="form-control bg-light"
                              id="priceHeadsDescription"
                              rows="2"
                              placeholder='Enter Brief Description of price heads here'
                              value={priceHeadsDescription} onChange={(e) => setPriceHeadsDescription(e.target.value)}
                            ></textarea>
                          </div>
                    </div>
                    </div>
                  </div>
            </div>
            <div className="row" style={{ backgroundColor: '#e5e5e5', padding: '10px' }}>
              <div className="col">
                <button className="btn" style={{ backgroundColor: 'white', color: 'black' }}>Cancel</button>
              </div>
              <div className="col text-right">
                <button className="btn" type='submit' style={{ backgroundColor: '#1ea072', color: 'white',marginLeft:'76%' }} onClick={handleSubmit}>Save and Submit</button>
              </div>
            </div>
        </div>
      <Footer/>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{ zIndex: 9999 }} 
      />
    </div>
    </>
  )
}
export default AddPriceHeads